export default __webpack_public_path__ + "static/media/Enterprise.4c5e5a04.svg";